import { focusBorder } from "../../../../theme/foundations/misc";
const ComponentStyle = {
    baseStyle: {
        _disabled: {
            backgroundColor: "semantic.background.disabled",
            opacity: 1,
            color: "semantic.text.disabled",
            borderColor: "transparent",
            _placeholder: {
                color: "semantic.text.disabled",
            },
        },
        _hover: {
            _disabled: {
                backgroundColor: "semantic.background.disabled",
                color: "semantic.text.disabled",
                borderColor: "transparent",
                _placeholder: {
                    color: "semantic.text.disabled",
                },
            },
        },
    },
    sizes: {
        default: {
            h: "120px",
            color: "semantic.text.primary",
            fontSize: "5",
            fontWeight: "core.demiBold",
            lineHeight: "core.10",
            pt: "3",
            pl: "3",
            pb: "6",
            _placeholder: {
                color: "semantic.icon.secondary",
            },
        },
    },
    variants: {
        filled: {
            background: "core.white",
            border: "1px solid",
            borderColor: "semantic.border.primary",
            _hover: {
                background: "core.boldyBlue.2",
                border: "1px solid",
                borderColor: "semantic.text.link",
                _placeholder: {
                    color: "semantic.text.link",
                },
            },
            _focus: focusBorder,
            _active: {
                border: "1px solid",
                borderColor: "semantic.outline.link",
            },
        },
        error: {
            background: "semantic.background.error",
            border: "1px solid",
            borderColor: "semantic.border.error",
            _focus: Object.assign(Object.assign({}, focusBorder), { background: "core.white" }),
            _active: {
                border: "1px solid",
                borderColor: "semantic.outline.link",
            },
        },
        success: {
            background: "core.white",
            border: "1px solid",
            borderColor: "semantic.border.primary",
            _hover: {
                background: "core.white",
                border: "1px solid",
                borderColor: "semantic.text.link",
            },
            _focus: focusBorder,
            _active: {
                border: "1px solid",
                borderColor: "semantic.outline.link",
            },
        },
    },
    defaultProps: {
        size: "default",
        variant: "filled",
    },
};
export default ComponentStyle;
//# sourceMappingURL=Textarea.default.js.map